import { render, staticRenderFns } from "./questionTip.vue?vue&type=template&id=529103b8&scoped=true"
import script from "./questionTip.vue?vue&type=script&lang=js"
export * from "./questionTip.vue?vue&type=script&lang=js"
import style0 from "./questionTip.vue?vue&type=style&index=0&id=529103b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529103b8",
  null
  
)

export default component.exports